import moment from 'moment';
import * as React from 'react';
import { ReactElement, useEffect } from 'react';

interface IProps {
    label: string;
    value: number;
}

export default function Time({ label, value }: IProps): ReactElement {
    useEffect(() => {
        // We need to be precise, when you reply to a quiz, 56 minutes left is not an hour left
        moment.relativeTimeThreshold('m', 59);
    }, []);

    return (
        <span>
            <i className="fa fa-clock-o"></i> <strong>{label}:</strong>{' '}
            {moment.duration(value, 'minutes').humanize()}
        </span>
    );
}
